export default __webpack_public_path__ + "static/media/img-1.fc0c2796.png";